import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Invitation from "@/pages/Invitation";
import PhotoUpload from "@/pages/PhotoUpload";
import Admin from "@/pages/admin/Admin";
import PrintCards from "@/pages/admin/PrintCards";

function App() {
  return (
    <div className="App paper-texture">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Invitation />} />
          <Route path="/invite/:token" element={<Invitation />} />
          <Route path="/photos/:code" element={<PhotoUpload />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/print" element={<PrintCards />} />
          <Route path="/admin/print/:tableId" element={<PrintCards />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
